export default "__VITE_ASSET__BnChxm07__"